module.exports = __webpack_public_path__ + "45f74d1cba6ea1a8275bb382231cb86f.jpg";